import { RootTypeProvider } from "../rootTypes/context/RootTypeContext";
import { UpdateDressCachePage } from "./UpdateDressCachePage";
import { DressCacheProvider } from "./context/DressCacheContext";

const UpdateDressCache = () => {
	return (
		<DressCacheProvider>
			<RootTypeProvider>
				<UpdateDressCachePage />
			</RootTypeProvider>
		</DressCacheProvider>
	);
};

export default UpdateDressCache;
